import { useQuery } from 'react-query'

import { API_URL } from 'utils/config'

import { useAxios } from '../index'

export default function useFactcheckerStats(modelTypes) {
  const axios = useAxios()

  const getStats = async modelTypes => {
    const { data } = await axios.get(
      `${API_URL}/factcheckers/statistics?modelTypes=${modelTypes}`
    )
    return data
  }

  return useQuery(['factchecker-stats', modelTypes], () => getStats(modelTypes))
}
